var map = {
	"app/turnos/turnos.module": [
		"H60V",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "n7du";


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src async
// module id = n7du
// module chunks = 2